import { DependencyList, useMemo } from 'react';

import { useSelector } from '@tdp';

import { LongRunningOperation, lroSlice } from '.';

export function createLroHooks<TState>(
  type: string,
  defaultState?: TState
) {
  function useLro(deps: DependencyList) {
    // Neat little nonce generator from https://www.codemzy.com/blog/random-unique-id-javascript
    const id = useMemo(() => Math.random().toString(36).substring(2), deps);
    function createLro(initialState?: TState) {
      return {
        id,
        type,
        status: 'inprogress',
        startTime: Date.now(),
        state: initialState ?? defaultState, //TODO(nibeauli): add sanity check here against undefined
      } as LongRunningOperation<TState>;
    }

    // Just cast the unknown back down to the 'correct' state.
    // The likelihood of a collision & therefore incorrect object is next to zero
    const lro = useSelector((state) =>
      lroSlice.selectors.selectById(state, id)
    ) as LongRunningOperation<TState> | undefined;
    return { lro, createLro };
  }

  return { useLro };
}
